"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var React = require("react");
var styled_components_1 = require("styled-components");
var Theme_1 = require("../../Theme");
var P = styled_components_1.default.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    font-size: 14px!important; /* required for SRW */\n"], ["\n    color: ", ";\n    font-size: 14px!important; /* required for SRW */\n"])), Theme_1.Color.Grey.G80);
var Text = function (_a) {
    var children = _a.children;
    return React.createElement(P, null, children);
};
exports.Text = Text;
var templateObject_1;
